module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/main-visual-988ec389be2d115dc5e98a5d30e34abd.png";